export const FLOATING_LAUNCHER_CLASS =
  "fixed z-layer-floating h-12 w-12 cursor-grab touch-none select-none rounded-full border border-primary-foreground/20 bg-primary p-0 text-primary-foreground shadow-2xl ring-4 ring-primary/15 transition-[background-color,box-shadow,opacity,transform,--tw-ring-color] duration-200 ease-out hover:-translate-y-0.5 hover:bg-primary/90 hover:shadow-2xl hover:ring-primary/25 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-ring/40 focus-visible:ring-offset-2 active:translate-y-0 active:scale-95 data-[dragging=true]:cursor-grabbing data-[dragging=true]:scale-105 data-[dragging=true]:shadow-2xl sm:h-14 sm:w-14";

export const FLOATING_LAUNCHER_ICON_CLASS = "h-5 w-5 sm:h-6 sm:w-6";

export const FLOATING_LAUNCHER_STACK = {
  assistant: 0,
  messages: 1,
  theme: 2,
  support: 3,
} as const;
